// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"52379478","453":"96453769"}[chunkId] + ".chunk.js";
};